import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import TimbradoComprobanteList from './list/TimbradoComprobanteList';
import TimbradoComprobanteSearch from './list/components/TimbradoComprobanteSearch';

const TimbradoComprobantes = (props) => {

  useEffect(() => {
    window.setAppTitle('Facturación');
  }, [])

  const handleOnRowClick = (data) => {
    props.history.replace({
      pathname: `/developers/timbrado/comprobantes/${data.id}`,
      state: {
        data: {...data}
      }
    });
  }

  return (
    <div>
      { Guardian.allows('developer.request.facturas') && (
        <>
          <Row>

            <Col sm="auto" md="9" className="mb-2">
              <TimbradoComprobanteSearch />
            </Col>

          </Row>


          <TimbradoComprobanteList onRowClick={ handleOnRowClick }/>
        </>
      )}
    </div>
  )
}

export default TimbradoComprobantes;